// extracted by mini-css-extract-plugin
export default {"container-select":"styled-select_container-select__wQ+So","inline":"styled-select_inline__Fe2fa","select":"styled-select_select__NHULQ","border":"styled-select_border__+t4Ma"};